<template>
  <div class="custom-input" ref="input">
    <div class="selected-option">
      <span v-if="isMandatory" class="asterisk">*</span>
      <span class="input-box">
        <span style="display: flex; flex-direction: column; width: 100%;">
          <span v-if="inputValue" class="custom-label">{{ placeholder }} </span>
          <input
            @input="updateInput"
            @focus="resetError"
            @keydown="validateNumber"
            v-model="inputValue"
            class="input-text"
            :placeholder="placeholder"
            :type="type"
            :key="updateKey"
          />
        </span>
        <div @click="clear()">
          <b-icon v-if="inputValue" icon="close" size="is-small"></b-icon>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomDetailsInput",
  data() {
    return {
      inputValue: this.value,
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    updateKey: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    value: null,
  },
  methods: {
    updateInput(event) {
      let value = event.target.value;
      if (this.type === "flyerNumber") {
        value = value.replace(/[^0-9]/g, "");
      }
      this.inputValue = value;
      this.$emit("input", this.inputValue);
    },
    resetError() {
      if (this.type == "card") {
        this.$emit("resetCardValidation");
      }
    },
    clear() {
      console.log("clear");
      this.inputValue = null;
      this.$emit("input", this.inputValue);
    },
    //validates the number field and removes all special number characters 
    validateNumber(event) {
      if (this.type === "number") {
        if (!/^\d$/.test(event.key) && event.key !== "Backspace") {
          event.preventDefault();
        }
      }
    }
  },
  mounted() {},
  watch: {
    value: function (val) {
      this.inputValue = val;
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.input-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.custom-label {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/primary/strong/2 */

  color: #5b626f;
}
.input-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  border: none !important;
  appearance: none !important;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;color: #30384a;
}

.input-text:focus-visible {
  outline: none;
}
.input-text::placeholder {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/placeholder */

  color: #878b95;
}
.custom-input {
  position: relative;
  background-color: #f6f6f4;
  height: 64px;
  border-radius: 8px;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
}
.selected-option {
  background-color: white;
  height: 64px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  line-height: 1.5;
  padding: 16px;
  position: relative;
  vertical-align: top;
  cursor: pointer;
  border: 2px solid #d1d2d6;
}
.options {
  position: absolute;
  max-height: 400px;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05), 0px 4px 4px -1px rgba(0, 0, 0, 0.05),
    0px 12px 16px -8px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}

.options::-webkit-scrollbar {
  display: none;
}
.option {
  padding: 16px;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
}
.option:hover {
  background: #f2f3f4;
}

.asterisk {
  color: red;
  padding-right: 8px;
  font-size: 20px;
}

</style>
